'use client'

import useSessionStore from '@/store/useSessionStore';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import styles from './HeaderLogin.module.scss';

export function HeaderLogin() {

  const [showDetails, setShowDetails] = useState(false);

  const location = usePathname();

  const session = useSessionStore(state => state.session);

  const handleToggleClick = () => {
    setShowDetails(!showDetails);
  };


  let links =
    <ul className={styles.loginMenu}>
      <li>
        <Link href='/customer/login' onClick={handleToggleClick}>
          Log In
        </Link>
      </li>
    </ul>

  if (session?.login_order_id  && location !== '/customer/logout') {
    links =
      <ul className={styles.loginMenu}>
        <li>
          <Link href={`/customer/order/${session.login_order_id}`} onClick={handleToggleClick}>
            {session.login_order_id}
          </Link>
        </li>
        <li>
          <Link href='/customer/logout' onClick={() => handleToggleClick}>
            Log Out
          </Link>
        </li>
      </ul>

  }

  return (
    <div className={styles.login}>
      <a className={styles.toggle} href="#na" onClick={handleToggleClick}>My order</a>

      {showDetails === true && links}

    </div>
  )
}
